import React from 'react';

const Familiar = () => {
    return (
        <div>
           <div className="container">
               <div className="row">
                   <div className="col-md-6">
                        <ul>
                            <li className='title1'><h3 className='text-white '>Html</h3></li>
                            <li className='title1'><h3 className='text-white '>Css</h3></li>
                            <li className='title1'><h3 className='text-white '>Bootstrap</h3></li>
                            <li className='title1'><h3 className='text-white '>Tailwind</h3></li>
                            

                        </ul>
                   </div>
                   <div className="col-md-6">
                        <ul>
                            <li className='title1'><h3 className='text-white '>Context API</h3></li>
                            <li className='title1'><h3 className='text-white '>Rest API</h3></li>
                            
                            <li className='title1'><h3 className='text-white '>Browser API</h3></li>
                            <li className='title1'><h3 className='text-white '>Payment Gateways</h3></li>

                        </ul>
                   </div>
               </div>
           </div>
        </div>
    );
};

export default Familiar;